// extracted by mini-css-extract-plugin
module.exports = {"entryModalWrapper":"EntryModal_entryModalWrapper__3TLW7","instructionHolder":"EntryModal_instructionHolder__3GdcT","arrowKeys":"EntryModal_arrowKeys__FoCwi"};